import { Component, OnInit } from '@angular/core';
import { environment } from "../../environments/environment";

@Component({
  selector: 'top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {

  vspOnlineUrl: string = environment.vspOnlineUrl;
  billerDirectUrl: string = environment.billerDirectUrl;
  labRefManualUrl: string = environment.labRefManualUrl;

  constructor() { }

  ngOnInit() {
  }

  canNavigate(): boolean {
    if (!environment.production) {
      alert('Biller Direct is not available in this environment. It is only available in production and sandbox.');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/top-nav/top-nav.component.ts